import apiClient from './client';
import type { Session } from '../types/session';

export const sessionsApi = {
  list: (teamId: string) =>
    apiClient.get<Session[]>(`/teams/${teamId}/sessions/`),

  create: (teamId: string) =>
    apiClient.post<Session>(`/teams/${teamId}/sessions/`),

  get: (teamId: string, sessionId: string) =>
    apiClient.get<Session>(`/teams/${teamId}/sessions/${sessionId}/`),

  end: (teamId: string, sessionId: string) =>
    apiClient.delete(`/teams/${teamId}/sessions/${sessionId}/`),
};
